import { useThemeUI } from 'theme-ui';

import type { Theme } from '../theme';

export function useTheme(): Theme {
	return useThemeUI().theme as Theme;
}
